// Only what BunnyCal actually supports: Google + Microsoft calendars; Zoom, Meet, Teams.
const ITEMS = [
  { code: "GC", name: "Google Calendar", body: "Read busy times & write confirmed events.", tint: "var(--lp-sky-soft)" },
  { code: "MC", name: "Microsoft Calendar", body: "Outlook & Microsoft 365 availability.", tint: "var(--lp-sky-soft)" },
  { code: "Z", name: "Zoom", body: "Auto-generate a link on confirm.", tint: "var(--lp-lilac-soft)" },
  { code: "GM", name: "Google Meet", body: "Native Meet links for every booking.", tint: "var(--lp-sage-soft)" },
];

const FEATURES = [
  "Two-way calendar sync",
  "Buffer time around meetings",
  "Multi-calendar busy reads",
];

function IconChip({ code, tint }: { code: string; tint: string }) {
  return (
    <span
      style={{
        display: "inline-flex",
        width: 44,
        height: 44,
        flex: "none",
        borderRadius: 12,
        background: tint,
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--lp-mono)",
        fontWeight: 500,
        color: "var(--lp-plum-700)",
      }}
    >
      {code}
    </span>
  );
}

const cardStyle: React.CSSProperties = {
  background: "var(--lp-cream)",
  border: "1px solid var(--lp-border)",
  borderRadius: "var(--lp-radius-card)",
  padding: 24,
  boxShadow: "var(--lp-shadow-soft)",
};

export function LandingIntegrations() {
  return (
    <section id="integrations" style={{ padding: "var(--lp-sec-y) 0" }}>
      <div
        className="lp-container stack-md"
        style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr", gap: 48, alignItems: "start" }}
      >
        {/* `lp-unstick` releases the sticky column below md — a pinned panel on a
            phone holds viewport hostage for content the reader has passed. */}
        <div className="lp-unstick" style={{ position: "sticky", top: 110 }}>
          <span className="lp-eyebrow" data-reveal>Integrations</span>
          <h2 className="lp-h1" data-reveal style={{ marginTop: 12 }}>
            Works with the <em>tools you already use.</em>
          </h2>
          <p className="lp-lede" data-reveal style={{ marginTop: 18, maxWidth: "38ch" }}>
            Pulls busy times from every calendar you've connected.
          </p>
          <div data-reveal style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 20 }}>
            {FEATURES.map((f) => (
              <span key={f} style={{ display: "flex", alignItems: "center", gap: 9, fontSize: 14, color: "var(--lp-plum-500)" }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--lp-lilac)" }} />
                {f}
              </span>
            ))}
          </div>
        </div>

        <div className="stack-md" data-reveal-group style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
          {ITEMS.map((it) => (
            <div key={it.name} className="lp-lift lp-integration-card" data-reveal style={cardStyle}>
              <IconChip code={it.code} tint={it.tint} />
              <h3 style={{ fontSize: 17, fontWeight: 600, margin: "16px 0 0", color: "var(--lp-plum-900)" }}>
                {it.name}
              </h3>
              <p style={{ fontSize: 14, color: "var(--lp-plum-400)", margin: "6px 0 0" }}>{it.body}</p>
            </div>
          ))}
          {/* Microsoft Teams spans the full width */}
          <div
            className="lp-lift lp-integration-card lp-integration-card-wide"
            data-reveal
            style={{ ...cardStyle, gridColumn: "span 2", display: "flex", alignItems: "center", gap: 18 }}
          >
            <IconChip code="MT" tint="var(--lp-blush-soft)" />
            <div>
              <h3 style={{ fontSize: 17, fontWeight: 600, margin: 0, color: "var(--lp-plum-900)" }}>
                Microsoft Teams
              </h3>
              <p style={{ fontSize: 14, color: "var(--lp-plum-400)", margin: "6px 0 0" }}>
                Teams meetings created on confirmation, for the whole org.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
